import { namespace } from 'vuex-class';
import { IFieldState } from './field.types';

export const Fields = namespace('dealroom/fields');

export const state: IFieldState = {
  loading: false,
  documentId: null,
  fields: [],
  selectedPageFieldIds: { pageId: null, fieldIds: [] },
  markedPageFieldIds: { pageId: null, fieldIds: [] },
  inEditMode: false,
  pageWidth: null,
  focusedFieldId: null,
  tabFieldId: null,
  senderSignature: '',
  lastUpdatedFieldId: null,
};

export enum EFieldAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',

  Add = 'add',
  Remove = 'remove',
  ReplaceCreatedField = 'replaceCreatedField',

  Update = 'update',
  UpdateFailed = 'updateFailed',

  Select = 'select',
  Deselect = 'deselect',
  DeselectAll = 'deselectAll',

  Tab = 'tab',
  Focus = 'focus',

  Duplicate = 'duplicate',
  DuplicateFailed = 'duplicateFailed',

  ChangeTextSize = 'changeTextSize',
  ChangeTextSizeFailed = 'changeTextSizeFailed',

  UpdatePageWidth = 'updatePageWidth',
  Align = 'align',
  AlignFailed = 'alignFailed',
  Move = 'move',

  LoadSenderSignature = 'loadSenderSignature',
  LoadSenderSignatureSuccess = 'loadSenderSignatureSuccess',
  LoadSenderSignatureFailed = 'loadSenderSignatureFailed',

  CorrectFieldPosition = 'correctFieldPosition',
  GetPageDimensions = 'getPageDimensions',

  SetLastUpdatedFieldId = 'setLastUpdatedFieldId',

  SetSelectBox = 'setSelectBox',
  EndSelectBox = 'endSelectBox',
}

export enum EFieldMutation {
  SetLoading = 'setLoading',
  SetDocumentId = 'setDocumentId',
  SetPageWidth = 'setPageWidth',
  Set = 'set',
  Add = 'add',
  Remove = 'delete',
  Update = 'update',
  ReplaceFieldWithTempId = 'replaceFieldWithTempId',
  SetId = 'setId',
  SetSelected = 'setSelected',
  Select = 'select',
  SetSelectedPageFieldIds = 'setSelectedPageFieldIds',
  Deselect = 'deselect',
  DeselectAll = 'deselectAll',
  SetFocusedFieldId = 'setFocusedFieldId',
  SetSenderSignature = 'setSenderSignature',
  SetTabFieldId = 'setTabFieldId',
  SetLastUpdatedFieldId = 'setLastUpdatedFieldId',
  SetSelectBox = 'setSelectBox',
}

export enum EFieldGetter {
  SelectedFields = 'selectedFields',
  FieldsToFillOut = 'fieldsToFillOut',
  LastUpdatedField = 'lastUpdatedField',
}
